import React from 'react';
import InlineFeedbackBase from './InlineFeedbackBase';

import TInlineFeedback from './types/TInlineFeedback';
import TEFeedbackSignal from '../../types/TEFeedbackSignal';

const Error = ({ children, ...rest }: TInlineFeedback) => (
  <InlineFeedbackBase {...rest} signal={TEFeedbackSignal.Error}>
    {children}
  </InlineFeedbackBase>
);

export default Error;
